class ShowHideRec extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("show-hide", this._handleShowHideRec.bind(this));
  }

  _handleShowHideRec(e) {
    e.preventDefault();

    if (this.getAttribute("as") == e.detail.target) {
      if (this.classList.contains("hidden")) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }
    } else {
      this.classList.add("hidden");
    }
  }
}
customElements.define("show-hide-rec", ShowHideRec);

class ShowHideEm extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this._handleClick.bind(this));
  }

  _handleClick(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent("show-hide", {
        detail: { target: this.getAttribute("target") },
      })
    );
  }
}
customElements.define("show-hide-em", ShowHideEm);
